import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!

  return (_ctx.isSprintHalted)
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(_component_BaseSubHeading, {
          color: "accent-03",
          darkColor: "accent-200",
          size: "large"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Sprint #" + _toDisplayString(_ctx.sprint?.sprint?.sequenceNumber ?? _ctx.$t("none")), 1)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("span", _hoisted_2, [
        _createTextVNode(" Sprint #" + _toDisplayString(_ctx.sprint?.sprintSequenceNumber ?? _ctx.$t("none")) + " " + _toDisplayString(_ctx.sprint?.startDate ?? _ctx.$t("none")) + " - " + _toDisplayString(_ctx.sprint?.endDate ?? _ctx.$t("none")) + " ", 1),
        _renderSlot(_ctx.$slots, "default")
      ]))
}